import Card from "./card.js";
export default class ImageOnly extends Card {
  constructor(s, t, i, h, r, e, l, n, o, a, u, c, d, m) {
    super(s, t, null, i, null, h, r, e, l, n, o, a, u, c, d, m),
      (this.U = "ab-image-only"),
      (this.V = !1),
      (this.test = !1);
  }
  tt() {
    const s = {};
    return (
      (s[Card.it.st] = Card.et.Pt),
      (s[Card.it.rt] = this.id),
      (s[Card.it.ot] = this.viewed),
      (s[Card.it.nt] = this.imageUrl),
      (s[Card.it.ut] = this.updated),
      (s[Card.it.lt] = this.created),
      (s[Card.it.ft] = this.categories),
      (s[Card.it.xt] = this.expiresAt),
      (s[Card.it.URL] = this.url),
      (s[Card.it.bt] = this.linkText),
      (s[Card.it.gt] = this.aspectRatio),
      (s[Card.it.jt] = this.extras),
      (s[Card.it.zt] = this.pinned),
      (s[Card.it.kt] = this.dismissible),
      (s[Card.it.qt] = this.clicked),
      (s[Card.it.vt] = this.test),
      s
    );
  }
}
